// "FIAT DUCATO · WE 12345" — name/marka with registration number everywhere.
export const vehicleLabel = (p, fallback = '—') => {
  if (!p) return fallback;
  const name = p.nazwa || p.nazwa_pojazdu || p.pojazd_name || [p.marka, p.model].filter(Boolean).join(' ');
  const nr = p.nr_rejestracyjny || p.numer_rejestracyjny;
  return [name, nr].filter(Boolean).join(' · ') || fallback;
};
